import React from 'react';
import { Form, Card, Alert } from 'react-bootstrap';
import FileUploadDemo from './shared/FileUploadDemo';

const RiberaStep2 = ({ formData, onChange }) => {
    const handleFileChange = (name, file) => {
        onChange({ ...formData, [name]: file });
    };

    const handleCheckboxChange = (e) => {
        onChange({ ...formData, prescripcionAdquisitiva: e.target.checked });
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 2: Documentación Administrativa</h5>
            </Card.Header>
            <Card.Body>
                <FileUploadDemo
                    label="Nota de pedido de Deslinde Abreviado de Dominio Público Hidráulico"
                    name="notaPedidoDeslinde"
                    accept=".pdf"
                    file={formData.notaPedidoDeslinde}
                    onChange={handleFileChange}
                    required={true}
                />

                <Form.Group className="mb-4">
                    <Form.Check
                        type="checkbox"
                        id="prescripcionAdquisitiva"
                        label="¿Corresponde a mensura por prescripción adquisitiva?"
                        checked={formData.prescripcionAdquisitiva || false}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Text className="text-muted">
                        Si marca esta opción, se excluye el requisito de Informe de Registro Inmobiliario
                    </Form.Text>
                </Form.Group>

                {!formData.prescripcionAdquisitiva && (
                    <FileUploadDemo
                        label="Informe de Registro Inmobiliario"
                        name="informeRegistro"
                        accept=".pdf"
                        file={formData.informeRegistro}
                        onChange={handleFileChange}
                        required={true}
                    />
                )}

                <FileUploadDemo
                    label="Nota de Autorización del Propietario (con firma digital)"
                    name="notaAutorizacion"
                    accept=".pdf"
                    file={formData.notaAutorizacion}
                    onChange={handleFileChange}
                    required={true}
                />

                <Alert variant="secondary" className="mt-3">
                    <small>
                        <strong>Nota:</strong> La nota de autorización debe estar firmada conforme al Art. 1015 del CCyCN
                        y los Art. 2 y 3 de la Ley Nacional N° 25.506 de Firma Digital.
                    </small>
                </Alert>
            </Card.Body>
        </Card>
    );
};

export default RiberaStep2;
